
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>BA (Honors) Economics </h1>
                </div>
            </div>
        </div>          
    </div>  
</section>    
<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row row-50">
            <div class="col-md-3">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">Eligibility </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">Duration</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">Subjects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">Affiliation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">Scope  and Prospects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">Fees And Intake</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>Eligibility </h3>                           
                           
                        </div>
                        <div class="text-left">
                            <p>10+2 or any other equivalent examination from a recognized board. Aspirants must have studied Mathematics or Statistics as a compulsory subject in Class 12 Age must be below 25 years.</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Duration
                            </h3>
                           
                        </div>  
                        <div class="text-left">                        
                            <p>3 years ( 6 Semesters)</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">                                
                        <div class="inner-title"  >
                            <h3>Subjects
                            </h3>
                           
                        </div>
                        <p>4/5 subjects per semester </p>
                       
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">                                
                        <div class="inner-title"  >
                            <h3>Affiliation
                            </h3>
                           
                        </div> 
                        <div class="text-left">                         
                            <p>RTM Nagpur University </p>
                        </div> 
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">                                
                        <div class="inner-title"  >
                            <h3>Scope  and Prospects
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Scope :</strong> Finance & Budget  Analyst  </li>
                            <li><strong>Prospects / Scope :</strong> Market Analyst, Economist, Business Content Writer , Economic Journalist</li>
                        </ul>
                    </div>
                 
                    <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">                                
                        <div class="inner-title"  >
                            <h3>Fees And Intake
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Fees  :</strong> : Rs 25,000 per year</li>
                            <li><strong>Intake :</strong>: 60 students  </li>
                        </ul>
                    </div>  
            </div>            
                <div class="text-center mt-5">
                    <a class="button-text" href="https://raisoni.nopaperforms.com/rgi" target="_blank">Apply Now</a>
                </div>
            </div>
        </div>
    </div>
</section>

